<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { heartbeat } from './api/index.js';

// 模块级单例，避免 HMR / 重复挂载时重复连接、重复心跳导致监听器堆积
let ethConnecting = false;
let heartbeatTimer = null;

export default {
  name: 'App',
  created() {
    this.connectToEthereum()
    this.startHeartbeat()
  },
  beforeDestroy() {
    this.stopHeartbeat()
  },
  methods: {
    startHeartbeat() {
      this.stopHeartbeat()
      const tick = () => {
        if (localStorage.getItem('token')) {
          heartbeat().catch(() => {})
        }
      }
      tick()
      heartbeatTimer = setInterval(tick, 5000)
    },
    stopHeartbeat() {
      if (heartbeatTimer) {
        clearInterval(heartbeatTimer)
        heartbeatTimer = null
      }
    },
    async connectToEthereum() {
      if (ethConnecting || this.$store.state.address) return;
      ethConnecting = true;
      try {
        await new Promise((resolve) => {
          setTimeout(resolve, 180)
        })
        if (!window.ethereum) {
          this.$router.push('/error');
          console.error('未找到以太坊 provider。请安装支持以太坊的钱包。');
          return;
        }
        // EIP-1102：仅请求账户地址，不实例化 Web3（避免 EventEmitter 监听堆积）
        const accounts = await window.ethereum.request({
          method: 'eth_requestAccounts',
        });
        const account = accounts && accounts[0];
        if (!account) return;
        this.$store.commit('updateAddress', account)
      } catch (error) {
        console.error('连接以太坊时出错: ', error);
      } finally {
        ethConnecting = false;
      }
    }
  }
}
</script>

<style>
#app {
  margin: 0;
  padding: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* margin-top: 60px; */
  background-color: var(--home-bg);
  width: 100vw;
  font-size: 17px;
  color: var(--home-text);
  min-height: 100vh;
  background-size: 100% 100%!important;

}


@import url("./assets/css/common.css");

.van-circle__text{
	font-size: 30px !important;
	font-weight: 700;
}


.kefu {
  position: fixed;
  right: 10px;
  top: 23vh;
  z-index: 999;
  img {
    width: 3.8rem;
    height: 3.8rem;
  }
}

.withdraw .van-cell{
	background: none;
	padding: 0;
}

.Recharge .content .content3 .van-cell .van-field__control{
	
}
.Recharge .content .btn{
	color: #fff!important;
} 
.RechargeDetails .content .content2 .time{
	color: #000!important;
}
</style>
